// extracted by css-extract-rspack-plugin
export default {"noScroll":"_ae7e8a55"};